import AppPageSubmitButton from "./AppPageSubmitButton";

import "./AppPageSubmitButton.scss";

export { AppPageSubmitButton as AppPageSubmitButton };